module.exports = __webpack_public_path__ + "img/Bettpickel.e07e5711.jpg";